export enum UserProfileImageSizes {
  image_50x50 = "50x50",
  image_25x25 = "25x25"
}
export enum ActivityImageSizes {
  image_210x127 = "210x127",
  image_287x191 = "287x191"
}